import { render, staticRenderFns } from "./RequestPasswordReset.vue?vue&type=template&id=3086332d"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports